import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { CrudService } from "src/app/Services/crud.service";
import { LoadingService } from "src/app/Services/loading.service";
import { LogedInUserService } from "src/app/Services/loged-in-user.service";

@Component({
  selector: "app-liveprojects",
  templateUrl: "./liveprojects.component.html",
  styleUrl: "./liveprojects.component.sass",
  standalone: false,
})
export class LiveprojectsComponent implements OnInit {
  isLoading = false;
  data = [];
  companyId = "";
  constructor(
    private crudService: CrudService,
    private toastr: ToastrService,
    private logedInUserService: LogedInUserService,
    private router: Router,
    private loadingService: LoadingService
  ) {}
  ngOnInit() {
    this.logedInUserService.get((response) => {
      if (response && response.companyId) {
        this.companyId = response.companyId;
        // this.fetchProjectManagementData(response.companyId);
        this.fetchLicenseHistories(response.companyId);
      }
    });
  }

  fetchLicenseHistories(companyId) {
    this.loadingService.show();

    this.crudService.get(
      null,
      (response) => {
        if (response) {
          if (
            response.error &&
            response.error.error &&
            response.error.error.message
          ) {
            this.toastr.error(
              response.error.error.message,
              "Invalid Operation"
            );
          } else {
            if (response.length) {
              this.data = response;
              console.log("recieved response here", this.data);
              this.loadingService.hide();

              // this.isLoading = false;
            } else {
              this.data = [];
              this.loadingService.hide();
              // this.isLoading = false;
            }
          }
        }
      },
      `licenseHistories?filter[where][companyId]=${companyId}`
    );
  }

  fetchProjectManagementData(companyId) {
    // this.isLoading = true;

    this.loadingService.show();
    this.crudService.get(
      null,
      (response) => {
        if (response) {
          if (
            response.error &&
            response.error.error &&
            response.error.error.message
          ) {
            this.toastr.error(
              response.error.error.message,
              "Invalid Operation"
            );
          } else {
            if (response.length) {
              this.data = response;
              this.loadingService.hide();

              // this.isLoading = false;
            } else {
              this.data = [];
              this.loadingService.hide();
              // this.isLoading = false;
            }
          }
        }
      },
      `projectManagements?filter[where][companyId]=${companyId}`
    );
  }
  applyFilter() {
    // this.fetchData(this.companyId);
  }
  changeSort(property) {}
  openPaymentPage(projectInfo) {
    this.router.navigate(["/payment-plan"], {
      queryParams: { projectManagementId: projectInfo.projectManagementId },
      state: { myData: projectInfo.id },
    });
  }
  getTransactionHistory(project) {
    console.log("transaction historyy", project);
    this.router.navigate(["/page/project-license-history"], {
      queryParams: { projectManagementId: project.projectManagementId },
    });
  }
}
